import { inject } from '@angular/core'

import { Observable, first, of, switchMap } from 'rxjs'

import { FlxModalService } from '@flowx/angular-ui-toolkit'
import { FlxApplicationSettingsComponent } from '@flowx/designer/modules/settings/application-settings.component'
import { ConfirmationModalComponent } from '@flowx/designer/shared/components/confirmation-modal/confirmation-modal.component'

export const applicationSettingsCanDeactivate = (
  component: FlxApplicationSettingsComponent
): Observable<boolean> | boolean => {
  if (component.applicationSettingsForm.pristine) {
    return true
  } else {
    const modalService = inject(FlxModalService)

    return modalService
      .show(
        ConfirmationModalComponent,
        { closeOnBackdropClick: false, backdropClass: 'overlay-backdrop' },
        {
          title: `Changes Unsaved`,
          message: `You have unsaved changes. Are you sure you want to exit page?`,
          btnOkText: `Discard Changes`,
          modalClass: 'pending-changes',
        }
      )
      .data$.pipe(
        first(),
        switchMap(({ confirm }) => {
          if (confirm) {
            component.applicationSettingsForm.patchValue({ ...component.settingsDefaultValues })
          }

          return of(confirm)
        })
      )
  }
}
